import _extends from 'babel-runtime/helpers/extends';

import { mapActions, mapState } from 'vuex';
var canupdate = true;
import { fmtSeconds } from '@com/utils/data-format';

export default {
  props: {
    url: String
  },
  data: function data() {
    return {
      audioSlider: 0,
      duration: 0,
      playing: false
    };
  },

  computed: _extends({}, mapState({
    workSpaceSetting: function workSpaceSetting(state) {
      return state.creative.template.workSpaceSetting;
    }
  }), {
    audioPlayer: function audioPlayer() {
      return this.$refs.audioPlayer;
    }
  }),
  watch: {
    url: function url(val) {
      var _this = this;

      if (val) {
        if (this.playing) {
          this.audioPlayer.pause();
          this.$nextTick(function () {
            _this.audioAutoPlay();
          });
        }
      }
    }
  },
  mounted: function mounted() {
    this.stopAudio();
  },

  methods: _extends({}, mapActions({
    stopAudio: 'creative/template/previewer/stopAudio',
    recoveryAudio: 'creative/template/previewer/recoveryAudio'
  }), {
    formatTooltip: function formatTooltip(val) {
      return fmtSeconds(val / 100 * this.duration).slice(3);
    },
    handleCanplay: function handleCanplay(_ref) {
      var target = _ref.target;

      this.duration = target.duration;
    },
    handlePlayerUpdate: function handlePlayerUpdate(_ref2) {
      var target = _ref2.target;

      if (canupdate) {
        this.audioSlider = parseInt(target.currentTime / this.duration * 100, 10);
      }
    },
    handleSliderChange: function handleSliderChange(val) {
      canupdate = false;
      this.audioPlayer.pause();
      this.audioSlider = val;
      this.audioPlayer.currentTime = Number((this.duration * val / 100).toFixed(2));
      console.log(val, Number((this.duration * val / 100).toFixed(2)));
      if (this.playing) {
        this.audioPlayer.play();
      }
      canupdate = true;
    },
    togglePlay: function togglePlay() {
      if (!this.duration) return;
      if (this.playing) {
        this.audioPlayer.pause();
      } else {
        this.audioPlayer.play();
      }
      this.playing = !this.playing;
    },
    audioAutoPlay: function audioAutoPlay() {
      this.playing = true;
      this.audioPlayer.play();
      this.stopAudio();
    }
  }),

  destroyed: function destroyed() {
    // 销毁的时候，如果非静音再启动声音
    if (!this.workSpaceSetting.toolbar_isMuted) {
      this.recoveryAudio();
    }
  }
};